<template>
  <m-products-2 class="mt-5 mb-3" :havePagination="true"/>
</template>

<script>
export default {
  name: 'Products'
}
</script>
